import type { MailboxInfo } from "owa-client-types";
import getExtensibilityState from "./getExtensibilityState";
import type { Extension } from "owa-addins-contracts";

export function getExtensionForAddinId(addinId: string, mailboxInfo: MailboxInfo): Extension | null {
    const extensibilityState = getExtensibilityState(mailboxInfo);
    const context = extensibilityState.Context;
    
    for (const ext of context?.Extensions || []) {
        if (ext.Id?.toLowerCase() === addinId.toLowerCase()) {
            return ext;
        }
    }
    return null;
}
